<template>
  <div>
    <TButton
      outline
     
      @click="showModal = true"
    >
      <TIcon
        :icon="['far', 'pencil']"
        class="mr-2"
      />{{ t(userAbout.length ? 'edit' : 'add') }}
    </TButton>

    <TModalCritical
      v-model:visible="showModal"
      :title="t('title')"
      :subtitle="t('placeholder')"
      size="lg"
      :is-loading="isFormLoading"
      :label-primary="t('actions.save')"
      :label-secondary="t('actions.cancel')"
     
      @action:primary="saveProfile"
      @action:secondary="handleCancel"
      @close="getSession()"
      @visible:content="focusOnEl"
    >
      <TForm
        novalidate
        @submit.prevent="saveProfile"
      >
        <TTipbox
          v-if="isFormFail"
          variant="error"
          is-dismissible
          class="mb-4"
          @dismissed="isFormFail = false"
        >
          {{ t('pages.profile.notification.error') }}
        </TTipbox>

        <TFormGroup :field="r$.about">
          <TTextarea
            id="bio"
            ref="bioEl"
            v-model="form.about"
            rows="10"
            :placeholder="t('placeholder')"
           
          />
        </TFormGroup>
      </TForm>
    </TModalCritical>
  </div>
</template>

<script setup lang="ts">
import { maxLength } from '@regle/rules'

const { t } = useI18n()

const { userAbout } = useUser()

const showModal = ref(false)
const isFormLoading = ref(false)
const isFormFail = ref(false)

const form = ref({
  about: userAbout.value,
})

const { r$ } = useRegle(form, {
  about: { maxLength: maxLength(4096) },
})

function handleCancel(dismiss: () => void) {
  form.value.about = ''
  dismiss()
}

const bioEl = useTemplateRef('bioEl')

function focusOnEl() {
  focusElementTextarea(bioEl.value?.$el, true)
}

const { $rentals, $captureError } = useNuxtApp()

const { getSession } = useAuth()

async function saveProfile(dismiss: () => void) {
  if (isFormLoading.value) {
    return
  }

  const { valid } = await r$.$validate()

  if (!valid) {
    return
  }

  isFormFail.value = false
  isFormLoading.value = true

  try {
    await $rentals('/api/user-profiles/me', {
      method: 'PUT',
      body: {
        About: form.value.about,
      },
    })

    dismiss()
  }
  catch (error) {
    $captureError(error)
    isFormFail.value = true
  }
  finally {
    isFormLoading.value = false
  }
}
</script>

<i18n lang="json">
{
  "en": {
    "edit": "Edit",
    "add": "Add bio",
    "title": "Edit bio",
    "placeholder": "Share a bit about yourself so your future guests or hosts can get to know you."
  },
  "fr": {
    "edit": "Modifier",
    "add": "Ajouter une bio",
    "title": "Modifier la biographie",
    "placeholder": "Parlez-nous un peu de vous pour que vos futurs voyageurs ou hôtes puissent vous connaître."
  }
}
</i18n>
